<template>
  <div>
    <div class="hero is-light-grey is-fullheight">
      <!-- Hero image -->
      <div class="hero-body animated preFadeInUp fadeInUp">
        <div class="container has-text-centered">
          <div class="columns is-vcentered">
            <div class="column is-5 caption-column has-text-right mt-40">
              <h1 class="title is-2 is-dark-wahda">
                خدمات مصرفية عبر الإنترنت متوفرة على مدار الساعة
              </h1>
              <div class="title-divider is-small"></div>
              <p class="mt-30">
                يقدم لك مصرف الصحارى خدمة
                <b class="is-primary">الصحارى أونلاين</b> التي تمكنك من متابعة
                وإدارة معاملاتك المصرفية اليومية من مكان تواجدك بكل يُسر وأمان
              </p>

              <div class="has-text-right">
                <div class="columns mt-20">
                  <div class="column">
                    <router-link to="/login">
                      <a class="button button-cta info-btn is-medium is-bold">
                        <b>تسجيل الدخول</b>
                      </a>
                    </router-link>
                  </div>
                  <div class="column">
                    <router-link to="/signup">
                      <a
                        class="button button-cta primary-btn is-medium is-bold"
                      >
                        <b>سجل في الخدمة من هنا</b>
                      </a>
                    </router-link>
                  </div>
                  <div class="column is-hidden-desktop">
                    <div class="pr-10 pl-10 pt-10">
                      <a class="is-disabled is-3">او</a>
                    </div>
                  </div>
                  <div class="column is-5 is-hidden-desktop">
                    <a
                      href="#product"
                      v-tooltip="
                        'يمكنك الاستفادة من هذه الميزة فقط من خلال زيارة هذه الصفحة عن طريق الهاتف النقال'
                      "
                      class="button is-medium is-bold"
                      >حمل التطبيق</a
                    >
                  </div>
                </div>
              </div>
              <div class="has-text-right">
                <div class="columns mt-20">
                  <div class="column">
                    <router-link to="/changePassword">
                      <a class="is-medium is-bold">
                        <b>نسيت كلمة المرور ؟</b>
                      </a>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-7">
              <img
                class="clean-hero-mockup mt-40 z-index-2"
                src="~/../assets/images/home/macbook-app2.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <!-- /Hero image -->
      <section
        id="services"
        class="section mt-80 section-primary is-medium animated preFadeInUp fadeInUp"
      >
        <div class="container">
          <!-- Title -->
          <div class="section-title-wrapper has-text-centered">
            <div>
              <h2 class="clean-section-title has-text-white has-text-bold">
                خدماتنا الان بكل سرعة
              </h2>
              <h3 class="subtitle is-5 pt-10 pb-10 has-text-white">
                تمتع بجميع خدماتنا بضغطة زر
              </h3>
            </div>
          </div>

          <div class="content-wrapper">
            <!-- Icon boxes -->
            <div class="columns is-vcentered">
              <div class="column is-8 is-offset-2 has-text-centered">
                <div
                  class="columns is-vcentered has-text-centered is-multiline"
                >
                  <!-- Icon box -->
                  <div class="column is-6">
                    <router-link to="/">
                      <div
                        class="flex-card icon-card-hover wallet-card light-bordered raised padding-20"
                      >
                        <h3 class="card-title is-clean">خدمات الحساب</h3>
                        <p class="card-description">
                          يمكنك من خلالها الاطلاع على رصيدك و كشف حسابك وغيرها من الخدمات.
                        </p>
                      </div>
                    </router-link>
                  </div>

                  <div class="column is-6">
                    <router-link to="/services/financial">
                      <div
                        class="flex-card icon-card-hover cash-card light-bordered padding-20"
                      >
                        <h3 class="card-title is-clean">خدمات مالية</h3>
                        <p class="card-description">
                          تتعلق هذه الخدمات بتحويل الأموال 
                        </p>
                      </div>
                    </router-link>
                  </div>

                  <div class="column is-6">
                    <router-link to="/services/visa">
                      <div
                        class="flex-card icon-card-hover visa-card light-bordered padding-20"
                      >
                        <h3 class="card-title">خدمات البطاقات الدولية (فيزا, ماستر كارد)</h3>
                        <p class="card-description">
                          لطلبات إصدار بطاقة ، تغيير حالة بطاقتك (إيقاف/إلغاء) ،
                          إعادة إصدار رقم سري،.
                        </p>
                      </div>
                    </router-link>
                  </div>

                  <div class="column is-6">
                    <router-link to="services/tejwal">
                      <div
                        class="flex-card icon-card-hover alzaad-card light-bordered padding-20"
                      >
                        <h3 class="card-title is-clean">
                          خدمات البطاقات المحلية 
                        </h3>
                        <p class="card-description">
                          لطلبات إصدار بطاقة ، تغيير حالة بطاقتك (إيقاف/إلغاء) ،
                          إعادة إصدار رقم سري.
                        </p>
                      </div>
                    </router-link>
                  </div>

                  <!-- <div class="column is-6">
                    <router-link to="/">
                      <div
                        class="flex-card icon-card-hover second-card light-bordered padding-20"
                      >
                        <h3 class="card-title is-clean">خدمات الهاتف النقال</h3>
                        <p class="card-description">
                          تمكنك من الاشتراك في خدمة الصحارى موبايل (خدمات مصرف
                          الصحارى عبر الهاتف المحمول).
                        </p>
                      </div>
                    </router-link>
                  </div>
                  <div class="column is-6">
                    <router-link to="/">
                      <div
                        class="flex-card icon-card-hover mobicash-card light-bordered padding-20"
                      >
                        <h3 class="card-title is-clean">خدمات الموبي كاش</h3>
                        <p class="card-description">
                          تمكنك من الاشتراك بخدمة الشراء عن طريق الهاتف النقال
                          (موبي كاش).
                        </p>
                      </div>
                    </router-link>
                  </div> -->

                  <div class="column is-6">
                    <router-link to="/">
                      <div
                        class="flex-card icon-card-hover first-card light-bordered padding-20"
                      >
                        <h3 class="card-title">خدمات إعادة المطالبة</h3>
                        <p class="card-description">
                          يمكنك من خلالها التقدم بطلب استرجاع مبالغ مخصومة نتيجة
                          حركات (شراء/سحب) غير ناجحة.
                        </p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <!-- Icon boxes -->
          </div>
        </div>
      </section>

      <section
        id="features"
        class="section section-feature-grey is-medium animated preFadeInUp fadeInUp"
      >
        <div class="container">
          <!-- Title -->
          <div
            class="section-title-wrapper has-text-centered animated preFadeInUp fadeInUp"
          >
            <div>
              <h2 class="clean-section-title">مميزات الصحارى أونلاين</h2>
              <h3 class="subtitle is-5 pt-10 pb-20">تعرف عليها الان</h3>
            </div>
          </div>

          <div class="content-wrapper animated preFadeInUp fadeInUp">
            <!-- Hover boxes -->
            <div class="columns is-vcentered">
              <div class="column"></div>
              <div class="column is-10">
                <div class="columns is-vcentered">
                  <!-- Icon box -->
                  <div class="column is-4">
                    <div class="square-icon-box rounded primary">
                      <div class="icon-box-wrapper">
                        <div class="icon-box">
                          <i class="material-icons">place</i>
                        </div>
                      </div>
                      <h3 class="mt-40 mb-40">
                        نقدم لك الخدمة إلى حيث مكان تواجدك
                      </h3>
                    </div>
                  </div>
                  <!-- Icon box -->
                  <div class="column is-4">
                    <div class="square-icon-box rounded primary">
                      <div class="icon-box-wrapper">
                        <div class="icon-box">
                          <i class="material-icons">flash_on</i>
                        </div>
                      </div>
                      <h3 class="mt-40 mb-40">
                        خدمات سريعة توفر لك الجهد والوقت
                      </h3>
                    </div>
                  </div>
                  <!-- Icon box -->
                  <div class="column is-4">
                    <div class="square-icon-box rounded primary">
                      <div class="icon-box-wrapper">
                        <div class="icon-box">
                          <i class="material-icons">https</i>
                        </div>
                      </div>
                      <h3 class="mt-40 mb-40">حسابك ومعلوماتك في أمان تام</h3>
                    </div>
                  </div>
                </div>
                <div class="columns is-vcentered">
                  <!-- Icon box -->
                  <div class="column is-4">
                    <div class="square-icon-box rounded primary">
                      <div class="icon-box-wrapper">
                        <div class="icon-box">
                          <i class="material-icons">watch_later</i>
                        </div>
                      </div>
                      <h3 class="mt-40 mb-40">
                        خدمات متوفرة 24 ساعة في اليوم لمدة سبعة أيام في الأسبوع
                      </h3>
                    </div>
                  </div>
                  <!-- Icon box -->
                  <div class="column is-4">
                    <div class="square-icon-box rounded primary">
                      <div class="icon-box-wrapper">
                        <div class="icon-box">
                          <i class="material-icons">chat_bubble</i>
                        </div>
                      </div>
                      <h3 class="mt-40 mb-40">
                        نحن على إطلاع على رأيك الشخصي وملاحظاتك عن النظام
                      </h3>
                    </div>
                  </div>
                  <!-- Icon box -->
                  <div class="column is-4">
                    <div class="square-icon-box rounded primary">
                      <div class="icon-box-wrapper">
                        <div class="icon-box">
                          <i class="material-icons">report_problem</i>
                        </div>
                      </div>
                      <h3 class="mt-40 mb-40">
                        تمكنك هذه الخدمة من الإبلاغ عن أي مشكلة تواجهك
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column"></div>
            </div>
            <!-- /Hover boxes -->
            <div
              class="has-text-centered is-title-reveal pt-40 pb-40 animated preFadeInUp fadeInUp"
            >
              <router-link to="/signup">
                <a class="button button-cta primary-btn is-large">
                  <b>سجل في الخدمة من هنا</b>
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    getSystemStatus() {
      axios
        .get("/services/mode")
        .then((response) => {
          if (response.status == 200) {
            if (
              response.data.status.trim() == "success".trim() &&
              response.data.maintenanceMode == true
            ) {
              this.$router.push("/maintenance");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getSystemStatus();
  },
};
</script>
